export enum ChakraSizes {
    xs = 'xs',
    sm = 'sm',
    md = 'md',
    lg = 'lg',
    xl = 'xl',
    full = 'full',
}

export enum IconSizes {
    xxs = '8px',
    xs = '10px',
    sm = '16px',
    md = '24px',
    lg = '32px',
    xl = '48px',
}
